import { PERIODS_DETAILS } from './constants'

export const getPeriodSelectOption = period => ({
    value: period,
    label: PERIODS_DETAILS[period].momentUnit.capitalize(),
})
